import { isApiError } from '@/lib/api/errors';

export const MAX_ADDITIONAL_CONTACTS = 10;

export const ADDITIONAL_CONTACT_LIMIT_MESSAGE =
  'This customer already has the maximum of 10 additional contacts.';

export function isAdditionalContactLimitError(error: unknown): boolean {
  return (
    isApiError(error) &&
    error.status === 400 &&
    error.message.toLowerCase().includes(`maximum ${MAX_ADDITIONAL_CONTACTS} additional contacts`)
  );
}
